import Grid2 from "@mui/material/Unstable_Grid2";
import { useDomesticMarketSpreadPriceProducerContext } from "../../../../../context/domestic-market/SpreadPrice/DomesticMarketSpreadPriceProducerContext";
import { CustomAutocomplete } from "../../../../../components/custom/CustomAutocomplete";
import { Box, Typography } from "@mui/material";
import { LooksOne } from "@mui/icons-material";
import { COLORS } from "../../../../../ui/Theme";

const CommodityForm1 = () => {
  const { 
    companies1,
    groups1,
    commodities1,
    inputProducerValues1,
    setInputProducerValues1,
  } = useDomesticMarketSpreadPriceProducerContext();

  const { company, group, commodity } = inputProducerValues1;

  const clearForm = (field) => {
    switch (field) {
      case "company":
        setInputProducerValues1((prev) => ({
          ...prev,
          group: null,
          commodity: null,
        }));
        break;
      case "group":
        setInputProducerValues1((prev) => ({
          ...prev,
          commodity: null,
        }));
        break;
      default:
        break;
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "10px",
      }}
    >
      <Typography
        sx={{
          fontSize: "16px",
          fontWeight: 900,
          display: "flex",
          alignItems: "center",
          justifyContent: { xs: "center", md: "flex-start" },
          gap: 0.5,
        }}
      >
        کالا
        <LooksOne sx={{ color: COLORS.BLUE }} />
      </Typography>

      <Grid2 container spacing={"10px"}>
        <Grid2 xs={12} md={4}>
          <CustomAutocomplete
            options={companies1.data}
            value={company}
            onChange={(e, newValue) => {
              setInputProducerValues1((prev) => ({
                ...prev,
                company: newValue,
              }));
              clearForm("company", newValue);
            }}
            isLoading={companies1.isLoading}
            placeholder="شرکت"
          />
        </Grid2>
        <Grid2 xs={12} md={4}>
          <CustomAutocomplete
            options={groups1.data}
            value={group}
            onChange={(e, newValue) => {
              setInputProducerValues1((prev) => ({ ...prev, group: newValue }));
              clearForm("group", newValue);
            }}
            isLoading={groups1.isLoading}
            placeholder="گروه"
          />
        </Grid2>
        <Grid2 xs={12} md={4}>
          <CustomAutocomplete
            options={commodities1.data}
            value={commodity}
            onChange={(e, newValue) => {
              setInputProducerValues1((prev) => ({
                ...prev,
                commodity: newValue,
              }));
              clearForm("commodity", newValue);
            }}
            isLoading={commodities1.isLoading}
            placeholder="کالا (اختیاری)"
          />
        </Grid2>
      </Grid2>
    </Box>
  );
};

export default CommodityForm1;
